"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Access = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
require("reflect-metadata");
const typedi_1 = require("typedi");
const access_types_1 = require("./access.types");
let Access = class Access {
    constructor(http, bridge, eventBus) {
        this.http = http;
        this.bridge = bridge;
        this.eventBus = eventBus;
        this.subscriptions = [];
        this.restoreDefaults();
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => __awaiter(this, void 0, void 0, function* () {
            yield this.fetchSubscriptionsData();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedUpdateUserData, () => __awaiter(this, void 0, void 0, function* () {
            yield this.fetchSubscriptionsData();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => {
            this.restoreDefaults();
        });
    }
    /**
     * Restores default access configuration
     */
    restoreDefaults() {
        const defaultConfig = this.defaultConfig;
        this.updateAppState(defaultConfig);
    }
    /**
     * Fetches user's subscriptions and update access configuration in the AppState
     */
    fetchSubscriptionsData() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: 'users/info/',
            });
            const { subscriptions } = (yield response.json());
            this.subscriptions = subscriptions;
            const accessConfig = this.convertSubscriptionsToAccessConfig();
            this.updateAppState(accessConfig);
        });
    }
    /**
     * Returns an instance of access configuration with default values
     */
    get defaultConfig() {
        return {
            actionMenu: {
                [bridge_schema_1.UIRestrictableElement.ActionMenuExportImageButton]: bridge_schema_1.UIAccessModifier.Restricted,
            },
            library: {},
            mainMenu: {},
            settings: {},
            systemsMenu: {},
            tabs: {},
        };
    }
    /**
     * Puts access config to the AppState
     *
     * @param {AccessConfig} config
     *
     * @private
     */
    updateAppState(config) {
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: 'accessConfig',
            keyPath: '',
            changes: config,
        });
    }
    /**
     * Converts backend response to the AppState object based on default config
     * @private
     */
    convertSubscriptionsToAccessConfig() {
        const defaultConfig = this.defaultConfig;
        return this.subscriptions.reduce((config, subscription) => {
            switch (subscription.bundle) {
                case access_types_1.SubscriptionBundle.ExportSnapshot:
                case access_types_1.SubscriptionBundle.ExportSnapshotB2B:
                    config.actionMenu[bridge_schema_1.UIRestrictableElement.ActionMenuExportImageButton] =
                        bridge_schema_1.UIAccessModifier.Regular;
                    break;
                default:
                    return config;
            }
            return config;
        }, defaultConfig);
    }
};
exports.Access = Access;
Access.exportName = 'access';
exports.Access = Access = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [http_1.HTTP,
        bridge_schema_1.BridgeInterface,
        event_bus_1.EventBus])
], Access);
